import {
	Card,
	CardContent,
	ExpansionPanel,
	ExpansionPanelDetails,
	ExpansionPanelSummary,
	Icon,
	Typography
} from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import React from 'react';
import OccupationQuestions from './CompanySpecificQuestions/occupation_questions';
import FMI from './CompanySpecificQuestions/fmi.jsx';
import Momentum from './CompanySpecificQuestions/momentum.jsx';
import Sanlam from './CompanySpecificQuestions/sanlam.jsx';

class CompanySpecific extends React.Component {
	getOccupation(targetName) {
		var occupation = this.props.client[`${targetName}Occupation`];
		if (!occupation) return this.props.client.occupation;
		return occupation;
	}

	companyComponents = [
		{
			id: 1,
			name: 'Momentum',
			component: props => (
				<Momentum {...props} forceUpdate={() => this.forceUpdate()} />
			)
		},
		{
			id: 3,
			name: 'Sanlam',
			logo: 'sanlam.png',
			component: props => (
				<Sanlam
					{...props}
					occupationQuestions={OccupationQuestions.filter(
						q =>
							q.oq_targetId === '3' &&
							q.oq_occupation === this.getOccupation('sanlam')
					)}
				/>
			)
		},
		{
			id: 10,
			name: 'Bidvest',
			component: props => (
				<FMI
					{...props}
					occupationQuestions={OccupationQuestions.filter(
						q =>
							q.oq_targetId === '10' &&
							q.oq_occupation === this.getOccupation('fmi')
					)}
				/>
			)
		}
	];

	componentDidMount() {
		this.props.scrollMeBar();
	}

	render() {
		const filteredCompanies = this.companyComponents.filter(c =>
			this.props.selectedTargets.includes(c.id)
		);
		return (
			<div className="contentWithStepper">
				<Card className={this.classes}>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Company Specific Questions"
						/>
						{filteredCompanies.length < 1 ? (
							<Typography>There are no Company Specific Questions</Typography>
						) : null}

						{filteredCompanies.map(company => {
							return (
								<ExpansionPanel defaultExpanded={true} key={company.id}>
									<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
										<Typography>{company.name}</Typography>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{company.component(this.props)}
									</ExpansionPanelDetails>
								</ExpansionPanel>
							);
						})}
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default CompanySpecific;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/CompanySpecific.jsx